var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4C14.3284 4 15 4.67157 15 5.5V6H17C17.5523 6 18 6.44772 18 7V8C18 8.55228 17.5523 9 17 9H16.924L16.3067 17.1511C16.2317 18.1419 15.4434 18.9188 14.4679 18.994L14.3125 19H9.68755C8.69388 19 7.85965 18.2726 7.71097 17.3057L7.69326 17.1511L7.076 9H7C6.44772 9 6 8.55228 6 8V7C6 6.44772 6.44772 6 7 6H9V5.5C9 4.67157 9.67157 4 10.5 4H13.5ZM15.9214 9H8.07862L8.69041 17.0755C8.72991 17.597 9.16457 18 9.68755 18H14.3125C14.8354 18 15.2701 17.597 15.3096 17.0755L15.9214 9ZM10.5 10C10.7761 10 11 10.2239 11 10.5V15.5C11 15.7761 10.7761 16 10.5 16C10.2239 16 10 15.7761 10 15.5V10.5C10 10.2239 10.2239 10 10.5 10ZM13.5 10C13.7761 10 14 10.2239 14 10.5V15.5C14 15.7761 13.7761 16 13.5 16C13.2239 16 13 15.7761 13 15.5V10.5C13 10.2239 13.2239 10 13.5 10ZM17 7H7V8H17V7ZM13.5 5H10.5C10.2239 5 10 5.22386 10 5.5V6H14V5.5C14 5.22386 13.7761 5 13.5 5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.68f35adfb1f2094d4abd3a5e3fdaabab.svg";
export { ForwardRef as ReactComponent };